import React, { Component } from "react";


import Grid from '@material-ui/core/Grid';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';


import DataTable from "../../components/DataTable";

import OrganizationStore from "../../stores/OrganizationStore";
import { withStyles } from "@material-ui/core/styles";
import { tableSortStyles, bindTableSortHandlers } from "../../classes/tableSort";
import TableCellLink from "../../components/TableCellLink";
import Delete from "mdi-material-ui/Delete";
import IconButton from '@material-ui/core/IconButton';

const styles = {
  ...tableSortStyles,
};


class UserOrganizationsList extends Component {
  constructor() {
    super();
    this.getPage = this.getPage.bind(this);
    this.getRow = this.getRow.bind(this);
    bindTableSortHandlers(this);
    this.onDelete = this.onDelete.bind(this);

    this.state = {
        orderBy:null,
        order:null
    }

    this.TableRef = React.createRef()
  }

  getPage(limit, offset, callbackFunc) {
    OrganizationStore.list("", limit, offset,  callbackFunc,this.state.orderBy, this.state.order,(this.props.user&&this.props.user.id)?this.props.user.id:undefined);
  }

  getRow(obj) {
    return(
      <TableRow
        key={obj.id}
        hover
      >
        <TableCell >{obj.id}</TableCell>
        <TableCellLink to={`/organizations/${obj.id}`}>{obj.name}</TableCellLink>
        <TableCell>{obj.displayName}</TableCell>
        <TableCell align="right">
                  <IconButton id={obj.id}  onClick={this.onDelete} className={'noUDpaddings'} aria-label="delete"><Delete /></IconButton>
         </TableCell>
       
      </TableRow>
    );
  }
  onDelete(e){
    if (window.confirm("Are you sure you want to remove the user from this organization? This does not remove the user itself.")) {
      OrganizationStore.deleteUser(e.currentTarget.id, this.props.user.id, resp => {
        this.TableRef.current.updateTable()
      });
    }
  }
  
  render() {
    return(
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <DataTable
            orderBy={this.state.orderBy}
            order={this.state.order}
            ref={this.TableRef}
            header={
              <TableRow>
                <TableCell {...this.makeCellSortProps('id')}>{this.makeSortLabel('id','Id')}</TableCell>
                <TableCell {...this.makeCellSortProps('name')}>{this.makeSortLabel('name','Name')}</TableCell>
                <TableCell {...this.makeCellSortProps('displayName')}>{this.makeSortLabel('displayName','Display name')}</TableCell>
                <TableCell></TableCell>
              </TableRow>
            }
            getPage={this.getPage}
            getRow={this.getRow}
          />
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(UserOrganizationsList);
